class IpRestriction {
    constructor(ipRestrictions) {
        this.ipRestrictions = ipRestrictions;
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.form = document.getElementById('frm-ipWhitelistForCpLoginForm-ipWhitelistForCpLoginForm');
        this.currentIpAddress = this.form ? this.form.querySelector('#current-ip-address').textContent : null;
        this.enableIpRestriction();
        this.ipRestrictionFormValidation();
        this.gwArr = null;

        if(window.location.href.indexOf('#ip_restrictions_tab') !== -1) {
            const groupsTab = document.querySelector('.nav-link[href="#ip_restriction_tab"]');
            bootstrap.Tab.getOrCreateInstance(groupsTab).show();
            $('.card-toolbar').addClass('d-none');
        }
    }
    addOrRemoveModalLoading(){
        // Init block ui
        const element = document.querySelector('#ip_restrictions_modal .modal-content');
        if(element){
            let blockUI = KTBlockUI.getInstance(element);
            if(!blockUI){
                blockUI = new KTBlockUI(element, {
                    overlayClass: "ga-bg-primary-200",
                });
            }
            if (blockUI.isBlocked()) {
                blockUI.release();
            } else {
                blockUI.block();
            }
        }
    }
    enableIpRestriction(){
        if(this.form){
            const thisClass = this;
            let enableIpRestrictionCheckbox = document.getElementById('ip-enable-restriction');
            if(enableIpRestrictionCheckbox){
                // On modal open -> get organization GW array  and init IPs tagify
                let ipRestrictionModal = document.getElementById('ip_restrictions_modal');
                ipRestrictionModal.addEventListener('show.bs.modal', function () {
                    if(!thisClass.gwArr){
                        thisClass.initIpsInput();
                    }
                });
                // When ip restriction modal is closed and checkox is checked with no restrictions -> uncheck checkbox
                ipRestrictionModal.addEventListener('hide.bs.modal', function () {
                    if(enableIpRestrictionCheckbox.checked && (!thisClass.ipRestrictions || thisClass.ipRestrictions.length === 0)){
                        enableIpRestrictionCheckbox.checked = false;
                    }
                });
                // Show Ip restriction modal or show disable ip restriction swal popup
                enableIpRestrictionCheckbox.addEventListener('change', function () {
                    if(this.checked){
                        bootstrap.Modal.getOrCreateInstance(ipRestrictionModal).show();
                    } else {
                        Swal.fire({
                            html: `<span class="text-center text-primary">Are you sure you want to disable IP restriction? All settings will be lost.</span>`,
                            icon: "warning",
                            iconColor: "#FF5206",
                            buttonsStyling: false,
                            reverseButtons: true,
                            showCancelButton: true,
                            confirmButtonText: "Yes, disable!",
                            customClass: {
                                confirmButton: "btn btn-danger mt-0",
                                cancelButton: 'btn btn-light-primary mt-0',
                            },
                            showLoaderOnConfirm: true,
                            returnFocus: false,
                            preConfirm: () => {
                                return naja.makeRequest('GET', '/mfa-and-login-security?do=disableIpRestriction', {
                                    'organizationID': thisClass.organizationID
                                }, {
                                    history: false // Prevent URL changes in browser history
                                }).then((response) => {
                                    if (response) {
                                        return response;
                                    }
                                });
                            },
                            allowOutsideClick: () => !Swal.isLoading(),
                            allowEscapeKey: () => !Swal.isLoading()
                        }).then((result) => {
                            if (result.isConfirmed) {
                                // Re-init ip restriction checkbox
                                thisClass.enableIpRestriction();
                                thisClass.ipRestrictions = result.ipRestrictions;
                                // Clear exclude admins select
                                $('select[name="excludeAdmins[]"]').val(null).trigger('change');
                                // Clear IPs tagify (insert all organization GWs)
                                let ipsInput = thisClass.form.querySelector('input[name="ips"]');
                                if(ipsInput.__tagify){
                                    ipsInput.__tagify.addTags(thisClass.gwArr, true, true);
                                    const currentIpAlert = thisClass.form.querySelector('#current-ip-alert');
                                    // Show current IP alert
                                    if(!thisClass.getIfImSelected() && !thisClass.getIfCurrentIpIsSelected()){
                                        currentIpAlert.classList.remove('d-none');
                                    }
                                }
                                toastr.success('IP Restrictions have been successfully disabled!');
                            } else {
                                // When swal is closed -> check checkbox again
                                enableIpRestrictionCheckbox.checked = true;
                            }
                        });
                    }
                })
            }
        }
    }
    initIpsInput(){
        if(this.form){
            const thisClass = this;
            thisClass.addOrRemoveModalLoading();
            let ipsInput = this.form.querySelector('input[name="ips"]');

            $.ajax({
                url: '?do=getAllOrganizationGateways',
                type: 'GET',
                dataType: '',
                data: {
                    organizationID: this.organizationID
                }
            }).done(function(gateways) {
                thisClass.gwArr = gateways;
                new IpsTagify(ipsInput, thisClass.gwArr, thisClass.currentIpAddress, thisClass.ipRestrictions);
                thisClass.addOrRemoveModalLoading();
            });
        }
    }
    initAdminsInput(){
        const thisClass = this;
        // Format Admin options
        const tagFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center py-1">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text +'</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }
        // Format Admin results
        const optionFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text + item.element.getAttribute('data-kt-rich-content-badges') +'</span>';
            template += '<span class="fw-semibold ga-text-primary-800 fs-8">' + item.element.getAttribute('data-kt-rich-content-subcontent') + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }

        // Init Select2
        const element = document.querySelector('select[name="excludeAdmins[]"]');
        const currentIpAlert = this.form.querySelector('#current-ip-alert');
        if(element) {
            $(element).select2({
                placeholder: "Select an option",
                templateSelection: tagFormat,
                templateResult: optionFormat,
                minimumResultsForSearch: -1,
                allowClear: true
            }).on('select2:select', function (e) {
                if(e.params.data.element.attributes['data-its-me'].value === '1'){
                    currentIpAlert.classList.add('d-none');
                }
            }).on('select2:unselect', function (e) {
                if(e.params.data.element.attributes['data-its-me'].value === '1'){
                    if(!thisClass.getIfCurrentIpIsSelected()){
                        currentIpAlert.classList.remove('d-none');
                    }
                }
            });
        }
    }
    getIfCurrentIpIsSelected(){
        const thisClass = this;
        let ipsInput = this.form.querySelector('input[name="ips"]');
        if(ipsInput){
            if(ipsInput.value){
                let selectedIPs = JSON.parse(ipsInput.value);
                if (selectedIPs.some(item => item.ip === thisClass.currentIpAddress)) {
                    return true;
                }
                return !!selectedIPs.some(item => item.value === thisClass.currentIpAddress);
            }
        }
        return false;
    }
    getIfImSelected(){
        let element = document.querySelector('select[name="excludeAdmins[]"]')
        let data = $(element).select2('data');
        return !!data.some(item => item.element.attributes['data-its-me'].value === '1');
    }
    ipRestrictionFormValidation(){
        if(this.form){
            const thisClass = this;
            this.initAdminsInput();
            let submitButton = document.getElementById('add_ip_restriction_form_submit');

            let validator = FormValidation.formValidation(
                this.form,
                {
                    fields: {
                        'ips': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required',
                                }
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                    }
                }
            );

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                validator.validate().then(function(status) {
                    if(status === 'Valid'){
                        // If I could lose access to organization after submit -> show warning swal
                        if(!thisClass.getIfCurrentIpIsSelected() && !thisClass.getIfImSelected()){
                            Swal.fire({
                                html: `
                                        <div class="text-center text-primary">Your current IP address (`+thisClass.currentIpAddress+`) <b>is not included</b> in the list of allowed IP addresses. If you save this setting, <b>you will lose access to the Control Panel</b> from your current IP address.</div>
                                        <div class="form-check mt-5">
                                            <input class="form-check-input float-none corsor-pointer" name="agreeSwalCheckbox" type="checkbox" value="" id="agreeSwalCheckbox" />
                                            <label class="form-check-label text-primary corsor-pointer" for="agreeSwalCheckbox">
                                                I agree
                                            </label>
                                        </div>`,
                                icon: "warning",
                                iconColor: "#FF5206",
                                buttonsStyling: false,
                                reverseButtons: true,
                                showCancelButton: true,
                                confirmButtonText: "Submit",
                                customClass: {
                                    confirmButton: "btn btn-danger mt-0",
                                    cancelButton: 'btn btn-light-primary mt-0',
                                },
                                showLoaderOnConfirm: true,
                                returnFocus: false,
                                preConfirm: () => {
                                    let deleteGatewaySwalCheckbox = document.querySelector('input[name="agreeSwalCheckbox"]');
                                    if(deleteGatewaySwalCheckbox && !deleteGatewaySwalCheckbox.checked){
                                        Swal.showValidationMessage(`You need to agree`);
                                        return;
                                    }
                                    return true;
                                },
                                allowOutsideClick: () => !Swal.isLoading(),
                                allowEscapeKey: () => !Swal.isLoading()
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    new DismissModal('ip_restrictions_modal').disable();
                                    // Show loading indication
                                    submitButton.setAttribute('data-kt-indicator', 'on');
                                    // Disable button to avoid multiple click
                                    submitButton.disabled = true;
                                    $('#frm-ipWhitelistForCpLoginForm-ipWhitelistForCpLoginForm').submit();
                                }
                            });
                        } else {
                            new DismissModal('ip_restrictions_modal').disable();
                            // Show loading indication
                            submitButton.setAttribute('data-kt-indicator', 'on');
                            // Disable button to avoid multiple click
                            submitButton.disabled = true;
                            $('#frm-ipWhitelistForCpLoginForm-ipWhitelistForCpLoginForm').submit();
                        }
                    }
                });
            });

            $.nette.ext('addIpRestrictionForm', {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === 'frm-ipWhitelistForCpLoginForm-ipWhitelistForCpLoginForm'){
                        if(payload){
                            if(payload.ipRestrictions){
                                thisClass.ipRestrictions = JSON.parse(payload.ipRestrictions);
                            }
                            toastr.success('Restrictions have been successfully added!');
                        } else {
                            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                        }

                        new DismissModal('ip_restrictions_modal').enable();
                        bootstrap.Modal.getInstance(document.getElementById('ip_restrictions_modal')).hide();

                        // Cancel loading indication
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;

                        thisClass.enableIpRestriction();

                        const popoverTriggerList = [].slice.call(document.querySelectorAll('#ip_restrictions_modal [data-bs-toggle="popover"]'));
                        popoverTriggerList.map(function (popoverTriggerEl) {
                            new bootstrap.Popover(popoverTriggerEl);
                        });
                    }
                }
            });
        }
    }
}
window.IpRestriction = IpRestriction;